import type { ApiChangeEmailPayload, ApiChangeEmailReferences } from 'src/types/userAuth';

import { useMutation } from '@tanstack/react-query';

import axios from 'src/utils/axios';

/**
 * POST /user/auth/email/change — requests an email change for the signed-in account and emails one
 * code to the NEW address and one to the address currently on the account (api#131). Runs under the
 * account session, whose token the api client sends with the request. Returns both OTP references;
 * a taken address answers 409 EMAIL_ALREADY_IN_USE.
 */
export const useChangeEmail = () =>
  useMutation({
    mutationFn: async (payload: ApiChangeEmailPayload): Promise<ApiChangeEmailReferences> => {
      const response = await axios.post<ApiChangeEmailReferences>(`/user/auth/email/change`, payload);
      return response.data;
    },
  });
